<template>
  <div class="results-app-component">
    <div class="section__controls justify-content-between" v-if="(pagination.total > 0 || items.length > 0)  && hasPermission('api.application.profile.results')">
      <div class="section__controls-group">
        <span v-if="app.isPublished" class="badge bg-primary">{{ getTranslation('publishedToTandoo') }}</span>
      </div>
      <div class="section__controls-group">
        <div v-if="isFinished && hasPermission('api.application.profile.downloadResult')" class="btn  btn--white btn--system  p-0">

          <select class="btn__select" v-model="fileFormats.allAppResults">
            <option :value="formats.excel">{{ formats.excel }}</option>
            <option :value="formats.pdf">{{ formats.pdf }}</option>
          </select>

          <a @click="downloadAppResults" class="btn__link" href="javascript:void(0)">
            {{ getTranslation('downloadResults', "(общая)") }}
          </a>
        </div>

        <div v-if="sendNrk || sendTandoo" class="btn  btn--white btn--system  p-0">

          <select class="btn__select bg-dark" v-model="publish">
            <option v-if="sendNrk" :value="'nrk'">{{ getTranslation('nrk') }}</option>
            <option v-if="sendTandoo" :value="'tandoo'">{{ getTranslation('tandoo') }}</option>
          </select>

          <a @click="publishApp(app.id,{sendResult:1})" class="btn__link" href="javascript:void(0)">
            {{ getTranslation('toPublish') }}
          </a>

        </div>

        <button v-if="isFinished && hasPermission('api.application.profile.downloadResult')" class="btn btn--main btn--sm" @click="downloadResults(app.id,{download:1})">
          {{ getTranslation('downloadResults', '(отдельно)') }}
        </button>

        <button v-if="hasPermission('api.application.profile.notifyCandidates') && pagination.total > 0" class="btn btn--accent-outline btn--sm" @click="notifyCandidates(app.id)">{{ getTranslation('notifyCandidates_results') }}</button>

        <!--            <button v-if="app.fromNrk" class="btn btn&#45;&#45;warning btn&#45;&#45;sm" @click="downloadResults(app.id,{sendFile:1})">{{getTranslation('sendFileResult')}}</button>-->
      </div>
    </div>
    <table class="table  table--noborder mt-5">
      <thead class="table__head">

      <tr class="table__row">
        <th class="table__cell  table__hcell" >
          <form @submit.prevent="fetchResults(appId)">
            <div class="field-advanced">
              <div class="field-advanced__inner">
                <div class="field-advanced__field-wrap">
                  <input type="text" :placeholder="getTranslation('searchByfioPin')" v-model="filterForm.query" class="field  field--full-width  field--bg-grey  js-borderOnFocus"></div>
                <div class="field-advanced__right">
                  <button class="btn  btn--square  btn--main">
                    <svg class="btn__icon">
                      <use xlink:href="#icon__search"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </th>
        <th class="table__cell  table__hcell" colspan="2">
          <v-select
              :options="formOptions.resultStatuses"
              :reduce="option=>option.id"
              label="title"
              :placeholder="getTranslation('selectFromList')"
              v-model="filterForm.resultStatus"
          />
        </th>
        <th class="table__cell  table__hcell">
          <v-select
              :options="formOptions.notificationStatuses"
              label="title"
              v-model="filterForm.notificationStatus"
              :reduce="option=>option.id"
              :placeholder="getTranslation('selectFromList')"
          />
        </th>
        <th class="table__cell  table__hcell">
          <v-select
              v-model="filterForm.loginType"
              label="title"
              :reduce="option=>option.id"
              :placeholder="getTranslation('selectFromList')"
              :options="formOptions.loginTypes"
          />
        </th>
      </tr>

      <tr class="table__row">
        <th class="table__cell  table__hcell" style="width: 23%">{{ getTranslation('candidates') }}-{{ items.length }}</th>
        <th class="table__cell  table__hcell" style="width: 12%;">{{ getTranslation('correctsResult') }} / {{ getTranslation('incorrectsResult') }}</th>
        <th class="table__cell  table__hcell" style="width: 15%;">{{ getTranslation('status') }}</th>
        <th class="table__cell  table__hcell" style="width: 18%;">{{ getTranslation('notification') }}</th>
        <th class="table__cell  table__hcell" style="width: 17%;">{{ getTranslation('identification') }}</th>
        <th class="table__cell  table__hcell" style="width: 0.2%;"></th>
      </tr>
      </thead>
      <tbody class="table__body">
      <tr v-for="item in items" class="table__row border-top">
        <td class="table__cell">
          <!-- PERSON -->
          <div class="person">
            <div class="person__inner">
              <div class="person__img">
                <a href="javascript:void(0)">
                  <img :src="item.candidate.photoUrl" alt="Фото сотрудника">
                </a>
              </div>

              <div class="person__info">
                <h3 class="person__name">
                  <router-link :to="{name:'api.candidate.get',params:{id:item.candidate.id}}" class="person__link">
                    {{ item.candidate.fullName }}
                  </router-link>
                </h3>
                <div class="person__descr">{{ item.candidate.pin }}</div>
                <div class="person__descr">
                  <span v-if="item.candidate.email">{{ item.candidate.email }}</span>
                  <span v-else class="text--danger">{{ getTranslation('noCandidateEmail') }}</span>
                </div>
              </div>
              <div class="candidate-icon" :class="{'winner-icon':item.isWinner,'retake-icon':item.hasToRetake,'d-none':!item.isWinner && !item.hasToRetake}">
                <div class="icon">
                  <svg>
                    <use xlink:href="#icon__favorites"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!-- / PERSON -->
        </td>

        <td class="table__cell">
          <TestResultsSwalComponent :item="item"/>

          <div v-for="(retake,key) in item.retakes" v-bind:key="key">
            <TestResultsSwalComponent :item="retake"/>
          </div>

        </td>

        <td class="table__cell">
          <ResultStatusComponent :item="item"/>

          <div v-for="(retake,key) in item.retakes" v-bind:key="key">
            <ResultStatusComponent :item="retake" :add-classes="'mt-3'"/>
          </div>

        </td>
        <td class="table__cell">
          <NotificationStatus v-if="item.candidate.notificationStatus && !item.hasToRetake" :is-result="item.hasToRetake" :status="item.candidate.notificationStatus"/>

          <div v-for="(retake,key) in item.retakes" v-bind:key="key">
            <NotificationStatus v-if="retake.candidate.notificationStatus" :add-classes="'mt-3'" :is-result="true" :status="item.candidate.notificationStatus"/>
          </div>

        </td>

        <td class="table__cell">
          <ResultLoginLabelComponent :item="item"/>

          <div v-for="(retake,key) in item.retakes" v-bind:key="key">
            <ResultLoginLabelComponent :item="retake" add-classes="mt-3"/>
          </div>

        </td>

        <td class="table__cell">
          <ActionsComponent
              :has-delete="false"
              :has-edit="false"
              :options="{
                  detailedResults:item.hasResult && hasPermission('api.candidate.profile.detailedResults'),
                  notifyCandidate:item.hasResult && hasPermission('api.application.profile.notifyCandidates'),
                  rejectRetake:item.hasToRetake,
                  cancelResult:canCancelResult(item)
              }"
              v-on:detailedResults="()=>{$router.push({name:'api.candidate.profile.detailedResults',params:{id:item.candidate.id,appId:appId},query:{resultId:item.result.id}})}"
              v-on:notifyCandidate="notifyCandidates(appId,item.candidate.id)"
              v-on:rejectRetake="rejectRetake(appId,item.candidateAppId)"
              v-on:cancelResult="openModal(item)"
          />

          <div v-for="(retake,key) in item.retakes" v-bind:key="key">
            <ActionsComponent
                add-classes="mt-3"
                :has-delete="false"
                :has-edit="false"
                :options="{
                    detailedResults:retake.hasResult && hasPermission('api.candidate.profile.detailedResults'),
                    notifyCandidate:retake.hasResult && hasPermission('api.application.profile.notifyCandidates'),
                    rejectRetake:retake.hasToRetake,
                    cancelResult:canCancelResult(retake)
                }"
                v-on:detailedResults="()=>{$router.push({name:'api.candidate.profile.detailedResults',params:{id:retake.candidate.id,appId:appId},query:{resultId:retake.result.id}})}"
                v-on:notifyCandidate="notifyCandidates(appId,retake.candidate.id,retake.result.eventId)"
                v-on:rejectRetake="rejectRetake(appId,retake.candidateAppId)"
                v-on:cancelResult="openModal(retake)"
            />
          </div>

        </td>
      </tr>
      <tr v-if="noPassedEvents && items.length===0" class="table__row">
        <td class="table__cell empty">
          {{ getTranslation('testingEventsNotFinished') }}
        </td>
      </tr>
      <tr v-else-if="items.length === 0" class="table__row">
        <td class="table__cell empty">
          {{ getTranslation('noResults') }}
        </td>
      </tr>
      </tbody>
    </table>

    <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
      <pagination :pagination="pagination" @change="()=>{fetchResults(appId);this.$scrollTo('.results-app-component');}" v-model="filterForm.page"></pagination>
    </div>

    <!-- cancel modal -->
    <modal
        v-model="showModal"
        :modal-title="getTranslation('resultsCancellation') +' ('+ this.selectedResult.candidate.fullName+')'"
        :ok-button-label="getTranslation('save')"
        :cancel-button-label="getTranslation('cancel')"
        @ok-button-click="cancelResult"
        @cancelButtonClick="resetModal"
        @input="resetModal"
        modal-class="col-md-8"
    >
      <form class="w-100">

        <div class="row">

          <div class="col-md-5">

            <div class="form__group" v-if="tests.length > 0">
              <label class="form__label">{{ getTranslation('testingTypes') }}<span class="required">*</span></label>

              <div class="checkbox-group  form__group ">
                <label class="checkbox types-checkbox " v-for="test in tests" v-bind:key="test.id">
                  <input v-model="cancelForm.testTypeIds" :id="'type-'+test.testTypeId" class="checkbox__input" type="checkbox" :value="test.testTypeId"/>
                  <span class="checkbox__indicator  checkbox__indicator--inline" :class="{'field--error':cancelForm.testTypesError}"></span>
                  <span class="checkbox__label">{{ test.testType }}</span>
                </label>
              </div>

            </div>

            <div class="form__group">
              <label class="form__label  form__label--block" for="shortArea">{{ getTranslation('resultCancellationComment') }} <span class="required">*</span> </label>
              <textarea class="field  field--full-width  field--short-area" :class="{'field--error':$v.cancelForm.comment.$error}" v-model="cancelForm.comment" id="shortArea" cols="30" rows="10"></textarea>
              <div v-if="$v.cancelForm.comment.$error" class="form__error">{{ getTranslation('requiredField') }}<span
                  class="required">*</span></div>
            </div>

          </div>

          <div class="col-md-7 border-left">

            <table class="table">
              <thead class="table__head">
              <tr class="table__row">
                <th class="table__cell  table__hcell" style="width: 20%;">{{ getTranslation('testType') }}</th>
                <th class="table__cell  table__hcell" style="width: 10%;">{{ getTranslation('startTime') }}</th>
                <th class="table__cell  table__hcell" style="width: 10%;">{{ getTranslation('finishTime') }}</th>
                <th class="table__cell  table__hcell" style="width: 10%;">{{ getTranslation('minimalPoint') }}</th>
                <th class="table__cell  table__hcell" style="width: 10%;">{{ getTranslation('candidateTestPoint') }}</th>
              </tr>
              </thead>

              <tbody class="table__body">

              <tr v-for="item in tests" v-bind:key="item.id" class="table__row">
                <td class="table__cell">{{ item.testType }}</td>
                <td class="table__cell">{{ item.startTime }}</td>
                <td class="table__cell">
                  <span v-if="item.endTime">{{ item.endTime }}</span>
                  <span v-else class="text--danger text--bold">--</span>
                </td>
                <td class="table__cell">{{ item.minimalPoint }}</td>
                <td class="table__cell text--bold" :class="{'text--danger':item.score < item.minimalScore,'text--success':item.score >= item.minimalScore}">{{ item.score }}</td>
              </tr>

              </tbody>
            </table>

          </div>
        </div>
      </form>


    </modal>

  </div>
</template>

<script>
import NotificationStatus from "./NotificationStatusComponent";
import reportMixin from "@/views/admin/reports/mixins/report";
import applicationMixin from "@/views/admin/applications/mixins/application";
import TestResultsSwalComponent from "@/views/admin/applications/components/results/TestResultsSwalComponent";
import ResultStatusComponent from "@/views/admin/applications/components/results/ResultStatusComponent";
import ResultLoginLabelComponent from "@/views/admin/applications/components/results/ResultLoginLabelComponent";

import {required} from "vuelidate/lib/validators";

export default {
  name: "ResultsComponent",
  mixins: [reportMixin, applicationMixin],
  components: {ResultLoginLabelComponent, ResultStatusComponent, TestResultsSwalComponent, NotificationStatus},
  props: ['appId', 'app', 'active'],
  data() {
    return {
      showModal: false,
      publish: 'tandoo',
      fileFormats: {
        allAppResults: '.pdf'
      },
      CONTEST_TYPE_OPEN: 3,
      items: [],
      comment: '',
      filterForm: {},
      pagination: {
        total: '',
        lastPage: '',
        currentPage: ''
      },
      isFinished: false,
      noPassedEvents: true,
      formOptions: {
        notificationStatuses: [],
        resultStatuses: [],
        loginTypes: []
      },
      tests: [],
      cancelForm: {
        resultId: '',
        comment: '',
        testTypeIds: [],
        testTypesError: false
      },
      selectedResult: {
        candidate: {fullName: ''}
      },
    }
  },
  created() {
    if (this.active)
      this.fetchResults(this.appId);


    this.setPublish();

    this.fetchAppCandidateOptions();

  },
  computed: {
    sendNrk() {

      if (!this.app.isFinished)
        return false;

      if (this.hasPermission('api.application.profile.downloadResult') && this.app.fromNrk)
        return true;

      return false;
    },
    sendTandoo() {

      if (!this.app.isFinished)
        return false;

      if (this.app.isPublished)
        return false;

      if (this.hasPermission('api.application.profile.publish') && this.app.appType === this.CONTEST_TYPE_OPEN)
        return true;

      return false;
    }
  },
  watch: {
    'active'(val) {
      if (val) {
        this.fetchResults(this.appId);
        this.setPublish();
      }

    },
    'filterForm.page'() {
      this.fetchResults(this.appId);
    },
    'filterForm.notificationStatus'() {
      this.fetchResults(this.appId);
    },
    'filterForm.resultStatus'() {
      this.fetchResults(this.appId);
    },
    'filterForm.loginType'() {
      this.fetchResults(this.appId);
    }
  },
  methods: {
    canCancelResult(item) {

      if (!this.hasPermission('api.candidate.testing.profile.cancel'))
        return false;

      if (!item.hasResult)
        return false;

      let result = item.result;

      if (!result.event.isPassed)
        return false;

      if (result.status !== 'FAILED' && result.status !== 'PASSED')
        return false;

      return true;

    },
    openModal(item) {

      this.getTests(item.result.id);
      this.cancelForm.resultId = item.result.id;

      this.selectedResult = item;

      this.showModal = true;
    },
    resetModal() {
      this.showModal = false;
      this.selectedResult = {
        candidate: {fullName: ''}
      };
      this.$v.$reset();

      this.cancelForm = {
        resultId: '',
        comment: '',
        testTypeIds: [],
        testTypesError: false
      };
    },

    cancelResult() {

      this.$v.cancelForm.$touch();

      if (this.tests.length > 0 && this.cancelForm.testTypeIds.length < 1) {
        this.cancelForm.testTypesError = true;
        return this.snotifyError('wrongFormMsg');
      }

      if (this.$v.cancelForm.$invalid)
        return this.snotifyError('wrongFormMsg');

      this.axios.post(this.$config.urls.candidate.candidateTesting.cancel.url.replace(':id', this.cancelForm.resultId), this.cancelForm)
          .then(response => {
            this.fetchResults(this.$route.params.id);

            this.snotifySuccess('saveSuccessMsg');

            this.resetModal();

          }).catch(() => {
      });

    },

    getTests(resultId) {

      if (!this.hasPermission('api.candidate.testing.profile.tests'))
        return;

      this.axios.get(this.$config.urls.candidate.candidateTesting.tests.url.replace(':id', resultId))
          .then(response => {
            this.tests = response.data.data;
          }).catch(() => {
      });

    },

    setPublish() {
      if (this.app.isPublished || (!this.sendTandoo && this.sendNrk))
        this.publish = 'nrk';
      else
        this.publish = 'tandoo';
    },

    async rejectRetake(appId, candidateAppId) {
      this.comment = await Swal.fire({
        title: '<label class="form__label reject--comment-label">' + this.getTranslation('rejectComment') + '<span class="required">*</span></label>',
        input: 'textarea',
        inputPlaceholder: this.getTranslation('writeRejectComment'),
        inputValidator: (value) => {
          if (!value) {
            return this.getTranslation('writeRejectComment');
          }
        },
        showCancelButton: true,
        cancelButtonText: this.getTranslation('cancel')
      });

      if (this.comment.value) {

        this.rejectRetakeApp(appId, {candidateAppId: candidateAppId, comment: this.comment.value})
            .then(() => {
              this.fetchResults(appId);
            })

      }
    },

    notifyCandidates(appId, candidateId = null, eventId = null) {
      Swal.fire({
        title: this.getTranslation('areYouSure'),
        text: this.getTranslation('cantRevertMsg'),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this.getTranslation('cancel'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.getTranslation('ImSure')
      }).then((result) => {
        if (result.value) {
          let data = {};

          if (candidateId)
            data.candidateId = candidateId;

          if (eventId)
            data.eventId = eventId;

          this.axios.post(this.$config.urls.application.notifyCandidates.url.replace(':id', appId), data)
              .then(() => {
                this.snotifySuccess('saveSuccessMsg');
                setTimeout(() => {
                  this.fetchResults(this.appId);
                }, 3000)
              }).catch(() => {
          });
        }
      });
    },

    fetchResults(appId) {
      let params = this.cleanObject({...this.filterForm});
      if (params.notificationStatus && params.notificationStatus === 'NOT_SENT') {
        params.notificationStatus = 'RESULT_NOT_SENT';
      }
      this.axios.get(this.$config.urls.application.fetchAppResults.url.replace(':id', appId), {params: params})
          .then(response => {
            this.items = response.data.data.results;
            this.isFinished = response.data.data.isFinished;
            this.noPassedEvents = response.data.data.noPassedEvents;
            this.pagination.currentPage = response.data.data.activePage;
            this.filterForm.page = response.data.data.activePage;
            this.pagination.total = response.data.data.totalItemsCount;
            this.pagination.lastPage = response.data.data.pages;
          }).catch(() => {
      });
    },

    fetchAppCandidateOptions() {
      this.axios.get(this.$config.urls.candidate.appCandidateOptions.url)
          .then(response => {
            this.formOptions.dispatch = this.objectToArray(response.data.data.dispatch, false, true);
            this.formOptions.loginTypes = this.objectToArray(response.data.data.loginTypes, false, true);

            for (let item of response.data.data.notificationStatuses) {
              if (item === 'RESULT_SENT' || item === 'NOT_SENT')
                this.formOptions.notificationStatuses.push({
                  id: item,
                  title: this.getTranslation('NOTIFICATION_' + item)
                });
            }

            for (let item of response.data.data.resultStatuses) {
              if (item !== 'TESTING_CANCELLED')
                this.formOptions.resultStatuses.push({
                  id: item,
                  title: this.getTranslation('CANDIDATE_' + item)
                });
            }
          }).catch(() => {
      });
    },

    downloadAppResults() {
      let params = {};
      params.format = this.fileFormats.allAppResults;
      this.axios.get(this.$config.urls.application.downloadAppResults.url.replace(':id', this.appId), this.getAxiosConfig(params))
          .then(response => {
            this.createDownloadLink(response, this.getTranslation('downloadResults', "(общая)"), params.format);
          })
    },

    publishApp(appId, params = {}) {

      if (params.sendResult) {

        if (this.publish === 'nrk')
          this.downloadResults(appId, params);

        if (this.publish === 'tandoo') {
          Swal.fire({
            title: this.getTranslation('publishResultsToTandoo') + '?',
            text: this.getTranslation('cantRevertMsg'),
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: this.getTranslation('cancel'),
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.getTranslation('OK')
          }).then((result) => {

            if (result.value) {
              this.axios.post(this.$config.urls.application.publish.url.replace(':id', appId))
                  .then(() => {
                    this.$emit('updateApp');
                    this.publish = 'nrk';
                  }).catch(() => {
              });
            }
          });
        }
      }


    },

    downloadResults(appId, params = {}) {

      if (params.sendFile || params.sendResult) {
        Swal.fire({
          title: this.getTranslation('areYouSure'),
          text: this.getTranslation('cantRevertMsg'),
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: this.getTranslation('cancel'),
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.getTranslation('ImSure')
        }).then((result) => {
          if (result.value) {
            this.getResults(appId, params);
          }
        });
      } else
        this.getResults(appId, params);


    },

    getResults(appId, params = {}) {

      let url = this.$config.urls.application.downloadResults.url.replace(':id', appId);

      if (params.appResult)
        url = this.$config.urls.application.downloadAppResults.url.replace(':id', appId);

      this.axios.get(url, {
        responseType: params.download ? 'blob' : 'json',
        params: params
      })
          .then(response => {
            let message = null;
            let success = 'success';

            if (!params.download)
              message = response.data.data.message;

            if (params.download) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', this.getTranslation('testingResults') + '-' + this.$moment().format('DD.MM.YYYY HH:mm') + '.xlsx');
              document.body.appendChild(link);
              link.click();
            } else if (params.sendFile) {
              if (message && message === success)
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: this.getTranslation('resultFileSentSuccess'),
                  showConfirmButton: false,
                  timer: 3000
                })
            } else if (params.sendResult) {
              if (message && message === success)
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: this.getTranslation('resultSentSuccess'),
                  showConfirmButton: false,
                  timer: 3000
                })
            }
          }).catch(() => {
      });
    }
  },
  validations: {
    cancelForm: {
      comment: {
        required
      }
    }
  }
}
</script>

<style scoped>
.status-icon {
  padding: 0 !important;
  margin: 0 !important;
}

.alert__icon {
  max-width: 25px;
}
</style>
